export enum LayoutDirection {
  COLUMN = 'column',
  ROW = 'row',
}

export enum LayoutAlignItems {
  START = 'start',
  CENTER = 'center',
  END = 'end',
  STRETCH = 'stretch',
  BASELINE = 'baseline',
}

export enum LayoutJustifyContent {
  START = 'start',
  CENTER = 'center',
  END = 'end',
  SPACE_BETWEEN = 'space-between',
}
